var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('footer',{style:(_vm.flag ? 'box-shadow: 0 -2px 4px 2px rgba(89,144,255,.2);' : '')})])
}
var staticRenderFns = []

export { render, staticRenderFns }